// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const keysResponseSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
  },
  {
    key: 'userId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'userId',
  },
  {
    key: 'key',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'key',
  },
  {
    key: 'whitelistedIPs',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'whitelistedIPs',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'whitelistedIPs[0]',
      },
    ],
  },
  {
    key: 'apiVersion',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'apiVersion',
  },
  {
    key: 'apiVersionUpdatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'apiVersionUpdatedAt',
  },
  {
    key: 'apiVersionDowngradeNotAllowedAfter',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'apiVersionDowngradeNotAllowedAfter',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'description',
    type: 'string',
    required: false,
    component: 'Textarea',
    fullPath: 'description',
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(keysResponseSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(keysResponseSchema)
}
